<template>
  <div class="scene-tile">
    <router-link class="scene-tile__image-link" :to="{name: 'scene', params: {id: scene._id}}">
      <div class="scene-tile__preview-container">
        <img class="thumbnail" v-if="scene.thumbnail" :src="imageUrlFor(scene.thumbnail).ignoreImageParams().width(480)"/>
        <img class="screens" v-if="scene.screencaps" :src="imageUrlFor(scene.screencaps).ignoreImageParams()"/>
      </div>
    </router-link>
    <router-link class="scene-tile__name" :to="{name: 'scene', params: {id: scene._id}}">
      <span>{{scene.name}}<div v-if="scene.favorite" class="scene-tile__favorite"></div></span>
      <div class="scene-tile__date">{{new Date(scene.release).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"})}}</div>
    </router-link>

    <h3 class="scene-tile__title">
      <div class="scene-tile__meta-wrapper">
        <div class="scene-tile__studio-wrapper">
          <ul class="scene-tile__studios" v-if="scene.studios" >
            <li class="scene-tile__studio" v-for="studio in scene.studios" :style="{ 'border-color': studio.color, 'background-color': studio.color + '0d' }">
              <router-link :to="{name: 'studio', params: {id: studio._id}}" >
                <div class="scene-tile__studio-name">{{studio.name}}</div>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="scene-tile__details">
          <ul v-if="scene.models" class="scene-tile__models">
            <li class="scene-tile__model" v-for="model in scene.models">
              <router-link class="scenes__model-link" :to="{name: 'model', params: {id: model._id}}">
                <div class="scene-tile__model-image"
                  v-bind:style="[{ backgroundImage: `url(${imageUrlFor(model.imageHeadshot)})`}]">
                </div>
                <div class="scene-tile__model-name">
                  {{model.name}}
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </h3>
  </div>
</template>

<script>
import sanity from "../sanity";
import imageUrlBuilder from "@sanity/image-url";
const imageBuilder = imageUrlBuilder(sanity);

export default {
  name: 'SceneTile',
  props: {
    scene: Object,
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    imageUrlFor(source) {
      return imageBuilder.image(source);
    }
  }
};
</script>

<style scoped>
.scene-tile {
  width: 100%;
}
.scene-tile__preview-container {
  font-size: 0;
  position: relative;
}
.scene-tile__preview-container .thumbnail {
  display: block;
  position: relative;
  width: 100%;
  height: auto;
  background: var(--color-mono-0);
  transition: opacity 0.35s ease-in-out;
  pointer-events: none;
  z-index: 2;
  border-radius: 5px;
}
.scene-tile__preview-container:hover .thumbnail {
  opacity: 0;
}
.scene-tile__preview-container .screens {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}

.scene-tile__preview-container, .image-container {
  display: block;
  position: relative;
  overflow: hidden;
  padding-bottom: 0;
  width: 100%;
  height: auto;
  border-radius: 5px;
  font-size: 0;
}
.scene-tile__preview-container:hover .screens {
  animation: screens 9s infinite step-end;
}

.scene-tile__favorite {
  display: flex;
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgb(0, 255, 72);
  margin-left: 12px;
  align-items: center;
}
.scene-tile__favorite:before {
  content: '';
  display: flex;
  position: absolute;
  top: 50%; 
  left: 50%;
  transform: translate(-50%,-50%);
  border-radius: 50%;
  background-color: rgb(0, 255, 72);
  align-items: center;
  width: 18px;
  height: 18px;
  transform-origin: top left;
  animation: favorite 3s infinite cubic-bezier(0.1, -0.6, 0.2, 0);
}

.scenes-list__model {
  display: block;
  font-size: 1rem;
}

.scene-tile__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 18px;
  margin: 16px 0;
  width: 100%;
}
.scene-tile__meta-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
}
.scene-tile__studio-wrapper {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: auto;
  margin-bottom: 12px;
  max-width: 100%;
}
.scene-tile__studios {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  padding: 0;
  font-size: 1.125rem;
  max-width: 100%;
  width: 100%;
}
.scene-tile__studios .scene-tile__studio {
  display: inline-flex;
  justify-content: center;
  font-size: 1rem;
  color: var(--color-mono-0);
  font-weight: 500;
  border-width: 1px;
  border-style: solid;
  padding: 4px 12px;
  margin-right: 12px;
  border-radius: 5px;
  width: 100%;
}
.scene-tile__studios .scene-tile__studio:only-child {
  margin-right: 0;
}
.scene-tile__studios .scene-tile__studio a {
  font-size: 0.875rem;
  color: var(--color-mono-0);
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}
.scene-tile__name {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-mono-0);
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  width: 100%;
  border-bottom: solid 1px var(--color-mono-5);
}
@media (max-width: 999px) {
  .scene-tile__name {
    flex-direction: column;
    align-items: flex-start;
  }
}
.scene-tile__name span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.scene-tile__date {
  font-size: 0.625rem;
  font-weight: 600;
}
@media (max-width: 999px) {
  .related-scenes .scene-tile__date {
    margin-top: 8px;
  }
}
.scene-tile__image-link {
  width: 100%;
}
.scene-tile__details {
  display: flex;
  width: auto;
  margin: 0;
  padding: 0;
}
.scene-tile__models {
    display: flex;
    width: auto;
    margin: 0;
    padding: 0;
    justify-content: flex-start;
    align-items: center;
}
.scene-tile__model {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-items: center;
  display: flex;
  height: 28px;
  margin-left: 18px;
  margin-bottom: 12px;
}
@media (max-width: 999px) {
  .scene-tile__model {
    margin-left: 0;
  }
}
.scene-tile__model:hover .scene-tile__model-image {
  transform: scale(1.075) translateY(-50%);
}

.scene-tile__model-name {
  font-size: 12px;
  padding-left: 36px;
  white-space: nowrap;
  font-weight: 500;
}
.scene-tile__model-image {
  display: block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: var(--color-mono-5);
  top: 50%;
  left: 0;
  position: absolute;
  transform: translateY(-50%);
  transform-origin: center;
  transition: transform 0.5s ease-in-out;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
